module.exports = __webpack_public_path__ + "img/program-ddp.0d2ecc54.jpg";